export const invoiceDeliveryNOteDiscrepancy = {
  INDN_discrepancy_item_dn_notfound: `Nota de entrega '{{2}}' no encontrada en el artículo '{{1}}'`,
  INDN_discrepancy_item_qty_mismatch: `El artículo '{{1}}' con cantidad '{{2}}' no coincide con la cantidad '{{4}}' de la nota de entrega '{{3}}'`,
  indn_item_description_not_attached: `La descripción del artículo '{{1}}' no está asociada a la factura '{{0}}'`,
  indn_item_referencecode_not_attached: `El código de referencia del artículo '{{1}}' no está asociado a la factura '{{0}}'`,
  inpo_item_description_not_attached: `La descripción del artículo '{{0}}' no está asociada a la factura '{{1}}'`,
  inpo_item_referencecode_not_attached: `El código de referencia del artículo '{{0}}' no está asociado a la factura '{{1}}'`,
  podn_item_description_not_attached: `La descripción del artículo '{{1}}' no está asociada a la nota de entrega '{{0}}'`,
  podn_item_referencecode_not_attached: `El código de referencia del artículo '{{1}}' no está asociado al código de referencia de la nota de entrega '{{0}}'`,
  consumed: "Consumada",
  effective: "Efectiva",
};
